import axios from "axios";
import { w3cwebsocket } from "websocket";
import moment from "moment";

const PRODUCTION = true;
export const APP_NAME = "SKOLHIVE";

export const SUPPORT_EMAIL = PRODUCTION
  ? getSupportEmail()
  : "support@example.com";

function getSupportEmail() {
  switch (APP_NAME) {
    case "CATHEDRAL":
      return "info@cathedralhighschool.in";
    case "SKOLHIVE":
      return "support@skolhive.com";
    case "CRIMSON":
      return "support@crimsonimpex.com";
  }
}

export const MAIN_TITLE = getTitle();

function getTitle() {
  switch (APP_NAME) {
    case "CATHEDRAL":
      return "Cathedral High School and PU College";
    case "SKOLHIVE":
      return "Skolhive EMS";
    case "CRIMSON":
      return "Crimson EMS";
  }
}

export const API_URL = PRODUCTION ? getURL() : "http://127.0.0.1:8000";

function getURL() {
  switch (APP_NAME) {
    case "CATHEDRAL":
      return "https://api.thecathedralhighschool.in";
    case "SKOLHIVE":
      return "https://api.skolhive.com";
    case "CRIMSON":
      return "https://api.crimsonimpex.com";
  }
}

export const WS_URL = PRODUCTION ? getWsURL() : "ws://127.0.0.1:8000";

function getWsURL() {
  switch (APP_NAME) {
    case "CATHEDRAL":
      return "wss://api.thecathedralhighschool.in";
    case "SKOLHIVE":
      return "wss://api.skolhive.com";
    case "CRIMSON":
      return "wss://api.crimsonimpex.com";
  }
}

export const DOMAIN_URL = PRODUCTION ? getDomainURL() : "http://127.0.0.1:8000";

function getDomainURL() {
  switch (APP_NAME) {
    case "CATHEDRAL":
      return "https://thecathedralhighschool.in";
    case "SKOLHIVE":
      return "https://skolhive.com";
    case "CRIMSON":
      return "https://www.crimsonimpex.com";
  }
}

export const ONLYLOGO = PRODUCTION ? getOnlyLogo() : "onlylogo_cathedral.png";

function getOnlyLogo() {
  switch (APP_NAME) {
    case "CATHEDRAL":
      return "onlylogo_cathedral.png";
    case "SKOLHIVE":
      return "onlylogo_skolhive.png";
    case "CRIMSON":
      return "onlylogo_crimson.png";
  }
}

export const APPBAR = PRODUCTION ? getAppBarLogo() : "appbar_cathedral.png";

function getAppBarLogo() {
  switch (APP_NAME) {
    case "CATHEDRAL":
      return "appbar_cathedral.png";
    case "SKOLHIVE":
      return "appbar_skolhive.png";
    case "CRIMSON":
      return "appbar_crimson.png";
  }
}

export const SIDEBAR = PRODUCTION ? getSideBarLogo() : "sidebar_cathedral.png";

function getSideBarLogo() {
  switch (APP_NAME) {
    case "CATHEDRAL":
      return "sidebar_cathedral.png";
    case "SKOLHIVE":
      return "sidebar_skolhive.png";
    case "CRIMSON":
      return "sidebar_crimson.png";
  }
}

export const LOGOSMALL = PRODUCTION
  ? getLogoSmall()
  : "logosmall_cathedral.png";

function getLogoSmall() {
  switch (APP_NAME) {
    case "CATHEDRAL":
      return "logosmall_cathedral.png";
    case "SKOLHIVE":
      return "logosmall_skolhive.png";
    case "CRIMSON":
      return "logosmall_crimson.png";
  }
}

export const GRADIENT = PRODUCTION
  ? getGradient()
  : "linear-gradient(to right, rgba(	15,	65,	57,0.9),  rgba(	15,	65,	57,0.9)), url(https://img.freepik.com/free-vector/education-pattern-background-doodle-style_53876-115365.jpg?w=740)";

function getGradient() {
  switch (APP_NAME) {
    case "CATHEDRAL":
      return "linear-gradient(to right, rgba(15,	65,	57,0.9),  rgba(15,	65,	57,0.9)), url(https://img.freepik.com/free-vector/education-pattern-background-doodle-style_53876-115365.jpg?w=740)";
    case "SKOLHIVE":
      return "linear-gradient(to right, rgba(70, 48, 8, 0.9),  rgba(70, 48, 8, 0.9)), url(https://img.freepik.com/free-vector/education-pattern-background-doodle-style_53876-115365.jpg?w=740)";
    case "CRIMSON":
      return "linear-gradient(to right, rgba(33,41,100,0.9),  rgba(33, 41, 100, 0.9)), url(https://img.freepik.com/free-vector/education-pattern-background-doodle-style_53876-115365.jpg?w=740)";
    case "ELEMZY":
      return "linear-gradient(to right, rgba(65, 15, 15, 0.9),  rgba(65, 15, 15, 0.9)), url(https://img.freepik.com/free-vector/education-pattern-background-doodle-style_53876-115365.jpg?w=740)";
  }
}

// "http://127.0.0.1:8000"
// "ws://127.0.0.1:8000"
// "https://api.elemzy.com"
// "wss://api.elemzy.com"

export const alertMessage = (type, title, message) => {
  return {
    type: "ALERT",
    payload: { type, title, message },
  };
};

export const getNotifications = () => (dispatch, getState) => {
  var state = getState();
  var body = {
    user_id: state.auth.user.user_id,
  };
  const config = {
    headers: {
      Authorization: state.auth.token,

      "Content-Type": "application/json",
    },
  };
  axios
    .post(API_URL + "/get_user_unseen_notifications", body, config)
    .then((res) => {
      var unseenNotifications = [];

      for (var i = 0; i < res.data.length; i++) {
        if (res.data[i]["seen"] == false) {
          unseenNotifications.push(res.data[i]);
        }
      }

      dispatch({
        type: "UNSEEN_NOTIFICATIONS_LOADED",
        payload: unseenNotifications.reverse(),
      });

      dispatch({
        type: "NOTIFICATIONS_LOADED",
        payload: res.data,
      });
    });
};

export const loadUser = () => (dispatch, getState) => {
  var state = getState();
  axios
    .get(API_URL + "/api/auth/user", {
      headers: {
        Authorization: state.auth.token,
      },
    })
    .then((res) => {
      if (res.data.is_parent) {
        var initAppInfo = {};
        initAppInfo["user"] = res.data;
        initAppInfo["token"] = state.auth.token;
        if (res.data.is_active) {
          const config = {
            headers: {
              Authorization: state.auth.token,
              "Content-Type": "application/json",
            },
          };
          var student_email = JSON.parse(res.data.student_email_list)[0][
            "user_id"
          ];
          if (student_email != null) {
            dispatch(loadStudent(student_email, res.data.user_id));
          }
          const client = new w3cwebsocket(
            WS_URL + "/ws/chat/" + res.data.channel_id + "/"
          );
          dispatch({
            type: "SOCKET_LOADED",
            payload: client,
          });
          dispatch({
            type: "INIT_APP_INFO",
            payload: initAppInfo,
          });
        } else {
          dispatch({ type: "AUTH_ERROR" });
        }
      } else {
        dispatch({
          type: "USER_LOADED",
          payload: res.data,
        });

        state = getState();
        const config = {
          headers: {
            Authorization: state.auth.token,
            "Content-Type": "application/json",
          },
        };
        const client = new w3cwebsocket(
          WS_URL + "/ws/chat/" + state.auth.user.channel_id + "/"
        );
        dispatch({
          type: "SOCKET_LOADED",
          payload: client,
        });
        var body = {};
        body["user_id"] = state.auth.user.user_id;
        body["institution_id"] = state.auth.user.institution_id;

        body = JSON.stringify(body);
        axios.post(API_URL + "/get_current_year", body, config).then((res) => {
          dispatch({
            type: "CURRENT_YEAR",
            payload: res.data,
          });
        });
        axios.post(API_URL + "/get_setup_status", body, config).then((res) => {
          dispatch({
            type: "SETUP_STATUS",
            payload: res.data,
          });
        });
        axios.post(API_URL + "/get_subscription", body, config).then((res) => {
          dispatch({
            type: "SUBSCRIPTION",
            payload: res.data,
          });
        });

        axios
          .post(API_URL + "/user_contacts", body, config)
          .then((res) => {
            dispatch({
              type: "CONTACTS_LOADED",
              payload: res.data,
            });
            axios
              .post(API_URL + "/user_messages", body, config)
              .then((res) => {
                var messages = res.data.sort((a, b) => {
                  return moment(
                    moment(b["updated_at"]).format("MM/DD/YYYY-HH:MM:SS")
                  ).diff(moment(a["updated_at"]).format("MM/DD/YYYY-HH:MM:SS"));
                });

                var tempChatsNew = [];
                var tempChatsRead = [];
                for (var i = 0; i < messages.length; i++) {
                  if (
                    messages[i][Object.keys(messages[i])[0]][
                      state.auth.user.user_id
                    ] &&
                    messages[i][Object.keys(messages[i])[0]][
                      state.auth.user.user_id
                    ] != 0
                  ) {
                    tempChatsNew.push(messages[i]);
                  } else {
                    tempChatsRead.push(messages[i]);
                  }
                }

                var newChats = tempChatsNew.concat(tempChatsRead);

                dispatch({
                  type: "MESSAGES_LOADED",
                  payload: newChats,
                });
              })
              .catch((err) => {
                console.log(err);
              });
          })
          .catch((err) => {
            console.log(err);
          });
      }
    })
    .catch((err) => {
      console.log(err);

      dispatch({
        type: "AUTH_ERROR",
      });
    });
};

export const loadStudent = (student_email, user_id) => (dispatch, getState) => {
  const state = getState();
  var body = JSON.stringify({ student_email, user_id });
  const config = {
    headers: {
      Authorization: state.auth.token,
      "Content-Type": "application/json",
    },
  };

  axios
    .post(API_URL + "/get_student_data", body, config)
    .then((res) => {
      var initAppInfo2 = {};

      initAppInfo2["student"] = res.data;
      initAppInfo2["institution_id"] = res.data.institution_id;

      var body = {};
      body["institution_id"] = res.data.institution_id;
      axios
        .post(API_URL + "/get_subscription", body, config)
        .then((res) => {
          initAppInfo2["subscription"] = res.data;
          axios
            .post(API_URL + "/get_current_year", body, config)
            .then((res) => {
              initAppInfo2["current_year"] = res.data;
              axios
                .post(API_URL + "/get_setup_status", body, config)
                .then((res) => {
                  initAppInfo2["setup_status"] = res.data;
                  try {
                    const initAppInfo2Copy = { ...initAppInfo2 };
                    dispatch({
                      type: "INIT_APP_INFO_2",
                      payload: initAppInfo2Copy,
                    });
                  } catch (err) {
                    try {
                      const initAppInfo2Copy = { ...initAppInfo2 };
                      dispatch({
                        type: "INIT_APP_INFO_2",
                        payload: initAppInfo2Copy,
                      });
                      dispatch(getNotifications());
                    } catch (err) {
                      console.log(err);
                    }
                  }
                })
                .catch((err) => {
                  console.log(err);
                });
            })
            .catch((err) => {
              console.log(err);
            });
        })
        .catch((err) => {
          console.log(err);
        });
    })
    .catch((err) => {
      console.log(err);
    });
};

// LOGIN USER
export const login = (user_id, password) => (dispatch) => {
  // Headers
  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  };

  var fireToken = "web";

  // Request Body
  const body = JSON.stringify({ user_id, password, fireToken });

  return axios
    .post(API_URL + "/api/auth/login", body, config)
    .then((res) => {
      dispatch({
        type: "LOGIN_SUCCESS",
        payload: res.data,
      });

      dispatch(loadUser());
      dispatch(alertMessage("SUCCESS", "Welcome!", "Login success."));
    })
    .catch((err) => {
      dispatch(
        alertMessage(
          "ERROR",
          err.toString(),
          err.response.data.non_field_errors[0]
        )
      );
      dispatch({
        type: "LOGIN_FAIL",
      });
    });
};

export const sendReset = (user_id) => (dispatch) => {
  // Headers
  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  };

  // Request Body
  const body = JSON.stringify({ user_id });

  axios
    .post(API_URL + "/api/password_reset/", body, config)
    .then((res) => {
      dispatch(
        alertMessage(
          "SUCCESS",
          "Email Sent.",
          "Check your email account for password reset link."
        )
      );
    })
    .catch((err) => {
      dispatch(
        alertMessage(
          "ERROR",
          err.response.status,
          Object.values(err.response.data)[0][0]
        )
      );
    });
};

export const passwordReset = (token, password) => (dispatch) => {
  // Headers
  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  };

  // Request Body
  const body = JSON.stringify({ token, password });

  axios
    .post(API_URL + "/api/password_reset/confirm/", body, config)
    .then((res) => {
      dispatch({
        type: "PASSWORD_RESET",
        payload: res.data,
      });
      dispatch(
        alertMessage("SUCCESS", "Success!", "Password was reset successfully.")
      );
    })
    .catch((err) => {
      var errString = "";
      for (var i = 0; i < Object.keys(err.response.data).length; i++) {
        for (
          var j = 0;
          j < err.response.data[Object.keys(err.response.data)[i]].length;
          j++
        ) {
          errString +=
            err.response.data[Object.keys(err.response.data)[i]][j] + "\n";
        }
      }
      dispatch(alertMessage("ERROR", err.response.status, errString));
    });
};

export const logout = () => (dispatch, getState) => {
  var state = getState();

  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  };

  config.headers["Authorization"] = state.auth.token;

  axios
    .post(API_URL + "/api/auth/logout", null, config)
    .then(() => {
      dispatch(
        alertMessage("SUCCESS", "Logout success.", "You have been logged out.")
      );
      dispatch({ type: "LOGOUT_SUCCESS" });
    })
    .catch((err) => {
      dispatch(
        alertMessage("SUCCESS", "Logout success.", "You have been logged out.")
      );
      dispatch({ type: "AUTH_ERROR" });
    });
};
